export default {	
	privList: [],
	objPrivEdit: [],
	runAdd: false
}
